<div class="mt-2">
    <plex-title size="sm" titulo="Agregar relaciones"></plex-title>
</div>

<paciente-buscar label="Buscar paciente" (searchStart)="onSearchStart()" (searchEnd)="onSearchEnd($event.pacientes)"
                 (searchClear)="onSearchClear()">
</paciente-buscar>

<plex-loader *ngIf="loading" type="ball-pulse"></plex-loader>

<paciente-listado [pacientes]="posiblesRelaciones" (selected)="seleccionarRelacionEntrante($event)" [offset]="160"
                  *ngIf="posiblesRelaciones?.length" [showRelaciones]="false">
</paciente-listado>

<div *ngIf="posiblesRelaciones && !posiblesRelaciones.length && !searchClear" class="alert alert-danger">
    <plex-icon name="account-alert"></plex-icon> No se encontró ningún paciente..
</div>

<!-- lista de un único elemento -->
<plex-list *ngIf="relacionEntrante">
    <plex-item>
        <!-- caso paciente relacionado -->
        <img *ngIf="relacionEntrante" [ngClass]="{'img-fallecido' : relacionEntrante}"
             [mpiFotoPaciente]="{ id: relacionEntrante.id, fotoId: relacionEntrante.fotoId }">
        <!-- caso paciente aun no relacionado -->
        <img *ngIf="!relacionEntrante.id && relacionEntrante.fotoId"
             [ngClass]="{'img-fallecido' : relacionEntrante.fechaFallecimiento}"
             [mpiFotoPaciente]="{ id: relacionEntrante.id, fotoId: relacionEntrante.fotoId }" alt="">

        <plex-label titulo="{{ relacionEntrante | nombre }}" subtitulo="{{ relacionEntrante | documento }}">
        </plex-label>

        <plex-label *ngIf="relacionEntrante.fechaNacimiento" titulo="{{ relacionEntrante | edad }}"
                    subtitulo="{{ (relacionEntrante.fechaNacimiento | fecha:'utc') || 'Desconocida' }}">
        </plex-label>

        <plex-grid size="sm" type="full">
            <plex-select class="vinculo" [(ngModel)]="relacionTipo" name="nuevaRelacion" [data]="parentescoModel"
                         [required]="true" placeholder="Seleccione vínculo...  ">
            </plex-select>

        </plex-grid>

        <!-- Se muestra con un 'OR' porque no todas las relaciones guardan el genero -->
        <plex-badge type="info">{{ relacionEntrante.genero || relacionEntrante.sexo }}</plex-badge>

        <plex-badge *ngIf="relacionEntrante.estado" type="" class=""
                    [ngClass]="{'text-success' : relacionEntrante.estado === 'validado' , 'text-warning' : relacionEntrante.estado === 'temporal'} ">
            {{ relacionEntrante.estado }}
        </plex-badge>

        <plex-badge type="danger" *ngIf="relacionEntrante.fechaFallecimiento"> Fallecido
        </plex-badge>
        <plex-button label="" type="success" size="sm" icon="{{esRelacionExistente ? 'check' : 'plus'}}"
                     tooltip="{{esRelacionExistente ? 'Actualizar' : 'Agregar'}}" [disabled]="!relacionTipo"
                     (click)="addRelacion(relacionEntrante)">
        </plex-button>

        <plex-button type="danger" size="sm" icon="close" tooltip="Cerrar" (click)="relacionEntrante = null">
        </plex-button>
        <div style="align-items: center;">
            <plex-bool type="slide" name="conviviente" [(ngModel)]="esConviviente" label="Es conviviente"></plex-bool>
        </div>
    </plex-item>
</plex-list>